/**
 * Customer-facing brand name (ClosingLane umbrella).
 * Domain model stays Deal + party + Milestone + Document — repo/package remain dealtracker.
 */
export const PRODUCT_NAME = "ClosingLane";
